/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { AiFillInfoCircle } from 'react-icons/ai';
import {
  AddMemberForm, Feedbacktext, InputLabel, InputWrapper, PopupInput, UpdateButton, ErrorText,
} from './addMemberPopupElements';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate';

// REGEX
const EMAIL_REGEX = /^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/;

const AddMemberPopup = ({
  setOpen, setData, role,
}) => {
  const axiosPrivate = useAxiosPrivate();

  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [memberEmail, setMemberEmail] = useState('');
  const [validEmail, setValidEmail] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!memberEmail) {
      return setFeedback('Email cant be empty');
    }

    // Security
    const v1 = EMAIL_REGEX.test(memberEmail);

    if (!v1) {
      setFeedback('Invalid Entry');
      return;
    }

    setLoading(true);

    axiosPrivate.post(
      '/changeMemberRole',
      JSON.stringify({
        memberEmail,
        memberRole: role,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status === 'error') {
        setLoading(false);
        setFeedback(res.data.message ? res.data.message : 'Something went wrong');
        setMemberEmail('');
      } else {
        setFeedback(res.data.message);
        setData((prev) => [
          ...prev,
          {
            Email: memberEmail,
            First_Name: res.data.name,
            Last_Name: res.data.surname,
          },
        ]);
        setMemberEmail('');
        setTimeout(() => {
          setLoading(false);
          setOpen(false);
          setFeedback('');
        }, 1000);
      }
    }).catch((error) => {
      setLoading(false);
      setFeedback(error.response.data.message ? error.response.data.message : 'Something went wrong');
      setMemberEmail('');
    });
  };

  // Email verification
  useEffect(() => {
    const result = EMAIL_REGEX.test(memberEmail);
    setValidEmail(result);
  }, [memberEmail]);

  // Error handling
  useEffect(() => {
    if (memberEmail) { setFeedback(''); }
  }, [memberEmail]);

  return (
    <AddMemberForm onSubmit={handleSubmit}>
      <InputWrapper>
        <InputLabel htmlFor="email">Member Email:</InputLabel>
        <PopupInput
          value={memberEmail}
          autoComplete="off"
          onChange={(e) => setMemberEmail(e.target.value)}
          aria-describedby="uidnote"
          type="email"
          name="email"
        />
      </InputWrapper>
      { memberEmail && !validEmail && (
      <ErrorText id="uidnote">
        <AiFillInfoCircle />
        &nbsp;
        Please enter a valid E-mail adress.
      </ErrorText>
      )}
      <UpdateButton disabled={loading} type="submit">{loading ? 'Giving role' : 'Give role'}</UpdateButton>
      {feedback && <Feedbacktext>{feedback}</Feedbacktext>}
    </AddMemberForm>
  );
};

export default AddMemberPopup;
